import React from 'react'
import { MDXTag } from '@mdx-js/tag'


const layoutProps = {};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props);
    this.layout = null;
  }

  render() {
    const {
      components,
      ...props
    } = this.props;
    return <MDXTag name="wrapper" components={components}><MDXTag name="p" components={components}><MDXTag name="a" components={components} parentName="p" props={{
          "href": "/snippets/main/graphql-mdx-posts/",
          "title": "MDX, GraphQL, all posts"
        }}>{`A snippet`}</MDXTag>{` with GraphQL to select all posts, ordered by the `}<MDXTag name="em" components={components} parentName="p">{`order`}</MDXTag>{` field of the frontmatter.`}</MDXTag>
      <MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{
          "className": "language-javascript"
        }}>{`query AllPosts {
  allMdx (
      filter:{
          fields:{slug: {regex: "/^/posts//" } }
      },
      sort: {
          fields: [frontmatter___order]
          order: ASC
      }          
  ){
    edges {
      node {
        frontmatter{
            title
            keywords
        }
        fields {
            slug
        }
        excerpt
      }
    }
  }
}
`}</MDXTag></MDXTag>
           </MDXTag>;
  }

}
export const _frontmatter = {
  "title": "GraphQL select all posts",
  "keywords": "Gatsby, GraphQL, all posts, MDX",
  "menu": "graphql/all posts"
};
    